// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"VW-z","sponsoredTooltipWrapper":"WW-z","sponsoredTooltip":"XW-z","newCard":"YW-z"};